//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime } from './../../components/helpers.js'
import { formatEmployeeName } from './OrderAdmittanceFunctions.js'

import TableEmployees from './../Employee/TableEmployees.vue'
import DateTimeField from './../../components/Field/DateTimeField.vue'

export default {
  components: {
    TableEmployees,
    DateTimeField
  },
  props: {
    orderAdmittance: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      formatEmployeeName: formatEmployeeName,
      selectedEmployee: null,
      employeeTable: '',
      modalOpened: false
    }
  },
  computed: {
    readonly: function () {
      return this.orderAdmittance.state !== 'AD3' && this.orderAdmittance.state !== 'AD5'
    }
  },
  methods: {
    onShowClosingEmployeeTable: function () {
      if (this.readonly) {
        return
      }
      this.employeeTable = 'closingEmployeeTable'
      this.selectedEmployee = this.orderAdmittance.closingEmployee
      this.modalOpened = true
    },
    saveClosingEmployee: function (employee) {
      if (!this.orderAdmittance.closingEmployee) {
        this.orderAdmittance.closingEmployee = {}
      }
      this.orderAdmittance.closingEmployee.fio = employee.shortName
      this.orderAdmittance.closingEmployee.key = employee.key
      this.orderAdmittance.closingEmployee.position = employee.positionName
      this.closeModal()
    },
    closeModal: function () {
      this.modalOpened = false
      this.selectedEmployee = null
    },
    formatDataFromUnixTime: function (unixTime) {
      if (unixTime) {
        return convertTime(unixTime)
      } else {
        return 'Нет данных'
      }
    }
  }
}

